import React from "react";
//#region types
//#endregion
//#region components
import { Skeleton } from "@mui/material";
//#endregion

const TopCardDescriptionOneSkeleton: React.FC = (props) => {
  return <Skeleton width="50%" height="32px" />;
};

export default TopCardDescriptionOneSkeleton;
